import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { createApi, formatApiError } from "@/lib/api";
import { Loading } from "@/components/common";

export default function AuthCallback() {
  const { adoptSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    const api = createApi("portal");
    (async () => {
      try {
        const { data } = await api.client.post("/auth/session", { session_id: sessionId });
        adoptSession(data);
        window.history.replaceState({}, "", "/portal");
        navigate("/portal", { replace: true });
      } catch (e) {
        setError(formatApiError(e.response?.data?.detail));
      }
    })();
  }, [adoptSession, navigate]);

  if (error)
    return (
      <div data-testid="auth-callback-error" className="mx-auto max-w-md p-10">
        <p className="rounded-xl bg-danger/10 px-4 py-3 text-sm text-danger">{error}</p>
        <button
          data-testid="auth-callback-back"
          onClick={() => {
            window.location.href = "/portal/login";
          }}
          className="mt-6 rounded-full bg-sage-600 px-6 py-3 text-sm text-bone"
        >
          Voltar ao login
        </button>
      </div>
    );

  return <Loading label="Concluindo login…" testId="auth-callback-loading" />;
}
